import { defineStore } from "pinia";
import type { Mate, Reply } from "@/types/entity";
import { useInteractive } from "./interactive";
import { showConfirmDialog } from "vant";
import { useInteractiveReview } from "./interactive-review";
import i18n from "@/locales";

export interface MateSelectorParam {
  selectedMateId?: number;
  mateOnly?: boolean;
  includeSelfAvatar?: boolean;
  selectionMode?: "edit" | "selection";
  exclude?: number[];
  callback?: (mate: Mate) => void;
  switchMate?: boolean;
  title?: string;
  showUnpublished?: boolean;
  onClick?: (mate: Mate) => void;
}

interface UIState {
  showSideDrawer: boolean;
  showMateSelector: boolean;
  showWechatDialog: boolean;
  showAnotherMateSelector: boolean;
  showMateLoading: boolean;
  showThemePicker: boolean;
  emojiPopup: {
    show: boolean;
    targetReply: Reply | null;
  };

  mateSelectorParam: MateSelectorParam;
}

const defaultMateSelectorParam: MateSelectorParam = {
  mateOnly: false,
  includeSelfAvatar: false,
  selectionMode: "selection",
  callback: () => {},
  exclude: [],
  switchMate: true,
  showUnpublished: false,
  selectedMateId: undefined,
};

export const useUI = defineStore("ui", {
  state(): UIState {
    return {
      showSideDrawer: false,
      showMateSelector: false,
      showAnotherMateSelector: false,
      showMateLoading: false,
      showWechatDialog: false,
      showThemePicker: false,
      emojiPopup: {
        show: false,
        targetReply: null,
      },
      mateSelectorParam: defaultMateSelectorParam,
    };
  },
  actions: {
    popMateSelector(params?: MateSelectorParam) {
      const newParam = { ...defaultMateSelectorParam, ...params };
      this.mateSelectorParam = newParam;
      this.showMateSelector = true;
    },
    popInteractivePoolMateSelector(callback?: (mate: Mate) => void) {
      const interactiveStore = useInteractive();
      const { t } = i18n.global;
      const reviewStore = useInteractiveReview();
      this.popMateSelector({
        title: t("interactive.joinInform.title"),
        mateOnly: true,
        switchMate: false,
        exclude: interactiveStore.poolList.map((v) => v.mateId) || [],
        callback: (mate) => {
          showConfirmDialog({
            message:
              t("interactive.poolTipsTitle") + t("interactive.poolTipsDesc"),
            confirmButtonText: t("Buttons.confirm"),
            cancelButtonText: t("Buttons.cancel"),
          })
            .then(async () => {
              console.log("confirm");
              await interactiveStore.addToPool(
                mate.id,
                mate.spritezz?.[0]?.id ?? undefined
              );
              this.showMateSelector = false;
              reviewStore.initOrFetchList(null, true);
            })
            .then(() => {
              callback?.(mate);
            });
        },
      });
    },
  },
});
